module.exports = "/assets/data/d59061ac2dfa67f7d12095c13f75031e-WC1B.data.json";